  <div class="container-fluid">
  <!-- At the moment this is a empy landing page just to show the alerts without distractions might have some other stuff later-->
  <br />
  <alert></alert>
  <br />
  <div class="mb-3">
    <span class="icon-left text-secondary"></span>
    <a [routerLink]="[destinoRouter]">   {{'WorkflowCreate.Back' | translate}}</a>
  </div>
  <div style="display: none">{{forceRender}}</div>
</div>
